export const unifiedValue = (value, props, digits) => (value * (props.multiplevalue || 1)).toFixed(digits || 1)